import { Box, styled } from "@mui/material";

export function FancyCard({ color, children, spacing, ...props }) {
  return (
    <WrapperCard my={spacing} color={color} {...props}>
      {children}
    </WrapperCard>
  );
}

const WrapperCard = styled(({ color, ...props }) => <Box {...props} />)(
  ({ color, theme }) => ({
    borderRadius: "20px",
    position: "relative",
    overflow: "hidden",
    background: color,
    padding: theme.spacing(2),
    width: "100%",
    
    "&::before": {
      zIndex: "0",
      content: '""',
      position: "absolute",
      background: theme.palette.common.black,
      opacity: ".1",
      width: "855px",
      height: "206px",
      borderRadius: "50%",
      bottom: "-120px",
      left: " -373px",
    },

    "&::after": {
      zIndex: "0",
      content: '""',
      position: "absolute",
      background: theme.palette.common.black,
      opacity: ".08",
      width: "657px",
      height: " 182px",
      borderRadius: "50%",
      top: "-90px",
      right: "-253px",
    },

    [theme.breakpoints.down("sm")]: {
      "&::before": {
        width: "320px",
        height: "160px",
        bottom: "-105px",
        left: "-150px",
      },
      "&::after": {
        width: "320px",
        height: "160px",
        top: "-90px",
        right: " -130px",
      },
    },
  })
);

export default FancyCard;
